"use strict";

import { authConstants, commonConstants, responseCodes } from "../_constants";

export const INITIAL_AUTH_STATE = {
  defaultLang: "en",
  changeSuccessAlertShow: false,
};

export function lang(state = INITIAL_AUTH_STATE, action) {
  switch (action.type) {
    case authConstants.CHANGE_LANGUAGE_SUCCESS_ALERT_HIDE:
      return {
        ...state,
        changeSuccessAlertShow: false,
      };

    case authConstants.CHANGE_LANGUAGE_SUCCESS_ALERT_SHOW:
      return {
        ...state,
        changeSuccessAlertShow: true,
      };

    case authConstants.CHANGE_LANGUAGE_COMPLETE:
      return {
        ...state,
        defaultLang: action?.payload?.customerLanguage,
        changeSuccessAlertShow: true,
      };

    case authConstants.OTP_CONFIRM_COMPLETE:
      return {
        ...state,
        changeSuccessAlertShow: false,
      };
  }

  return state;
}
